import { defineComponent } from "@histoire/vendors/vue";
const _sfc_main = defineComponent({
  inheritAttrs: false,
  props: {
    exact: {
      type: Boolean,
      default: false
    },
    matched: {
      type: Boolean,
      default: null
    }
  }
});
export {
  _sfc_main as default
};
